import axiosInstance from "./api";
import { 
  Campaign, 
  Pitch, 
  CreateCampaignRequest, 
  CreatePitchRequest, 
  UpdatePitchStatusRequest,
  UpdatePitchDraftRequest,
  SendPitchEmailRequest,
  EmailMessage
} from "../types/outreach";

const BASE_URL = "/outreach";

export const outreachService = {
  // Campaigns
  getCampaigns: async (): Promise<Campaign[]> => {
    const response = await axiosInstance.get<{ data: Campaign[] }>(`${BASE_URL}/campaigns`);
    return response.data.data;
  },

  createCampaign: async (data: CreateCampaignRequest): Promise<Campaign> => {
    const response = await axiosInstance.post<{ data: Campaign }>(`${BASE_URL}/campaigns`, data);
    return response.data.data;
  },

  getCampaignPitches: async (campaignId: string): Promise<Pitch[]> => {
    const response = await axiosInstance.get<{ data: Pitch[] }>(`${BASE_URL}/campaigns/${campaignId}/pitches`);
    return response.data.data;
  },

  // Pitches
  createPitch: async (data: CreatePitchRequest): Promise<Pitch> => {
    const response = await axiosInstance.post<{ data: Pitch }>(`${BASE_URL}/pitches`, data);
    return response.data.data;
  },

  updatePitchStatus: async (pitchId: string, data: UpdatePitchStatusRequest): Promise<Pitch> => {
    const response = await axiosInstance.put<{ data: Pitch }>(`${BASE_URL}/pitches/${pitchId}/status`, data);
    return response.data.data;
  },

  updatePitchDraft: async (pitchId: string, data: UpdatePitchDraftRequest): Promise<Pitch> => {
    const response = await axiosInstance.put<{ data: Pitch }>(`${BASE_URL}/pitches/${pitchId}/draft`, data);
    return response.data.data;
  },

  sendPitchEmail: async (pitchId: string, data: SendPitchEmailRequest): Promise<EmailMessage> => {
    const response = await axiosInstance.post<{ data: EmailMessage }>(`${BASE_URL}/pitches/${pitchId}/email`, data);
    return response.data.data;
  },

  getPitchEmails: async (pitchId: string): Promise<EmailMessage[]> => {
    const response = await axiosInstance.get<{ data: EmailMessage[] }>(`${BASE_URL}/pitches/${pitchId}/emails`);
    return response.data.data;
  }
};

